import { IPage, registerPage } from '../Components/Page';
import { useInitAsync } from '../Utils';
import { useLocation, useParams } from 'react-router';
import apiClient, { ITicketData } from '../Services/ApiClient';
import { Fragment, useState } from 'react';
import Home from './Home';
import Field from '../Components/Field';
import { useNetwork } from '../Hooks/Network';
import "./TicketDetails.scss"


interface ITicketDetailsParams {
    ticket?: ITicketData;
}

export function TicketDetailsContent(params: ITicketDetailsParams) {

    const network = useNetwork();

    const { state } = useLocation();

    const { eventId, barcode } = useParams();

    const [ticket, setTicket] = useState(params.ticket ?? (state as ITicketDetailsParams)?.ticket);

    useInitAsync(async () => {

        if (!ticket) {  

            const result = await network(() => apiClient.getTicketDataAsync({
                eventID: eventId,
                searchMethod: "barcode",
                searchString: barcode
            }));
            setTicket(result[0]);
        }

    });

    if (!ticket) 
        return null;

    const dataemissione = !isNaN(ticket.dataemissione as number) ? ticket.dataemissione?.toString() : ticket.dataemissione as string;
    const oraemissione = !isNaN(ticket.oraemissione as any) ? ticket.oraemissione?.toString() : ticket.oraemissione as string;

    const emissionDate = dataemissione && oraemissione ?
        (dataemissione.substr(6, 2) + "/" +
            dataemissione.substr(4, 2) + "/" +
            dataemissione.substr(0, 4) + " " +
            oraemissione.substr(0, 2) + ":" +
            oraemissione.substr(2, 2))
        : null;


    const dataingressocontrollo = !isNaN(ticket.dataingressocontrollo as number) ? ticket.dataingressocontrollo?.toString() : ticket.dataingressocontrollo as string;
    const oraingressocontrollo = !isNaN(ticket.oraingressocontrollo as number) ? ticket.oraingressocontrollo?.toString() : ticket.oraingressocontrollo as string;

    const checkDate = oraingressocontrollo && oraingressocontrollo ?
        (dataingressocontrollo.substr(6, 2) + "/" +
            dataingressocontrollo.substr(4, 2) + "/" +
            dataingressocontrollo.substr(0, 4) + " " +
            oraingressocontrollo.substr(0, 2) + ":" +
            oraingressocontrollo.substr(2, 2))
        : null;


    return (
        <Fragment>
            <header>Dettaglio titolo</header>
            <fieldset>
                <Field label="Codice a Barre">{ticket.barcode}</Field>
                <Field label="Rif. Ordine">{ticket.riferimentoordine}</Field>
                <Field label="Data Emissione">{emissionDate}</Field>
                <Field label="Sigillo">{ticket.sigillofiscale}</Field>
                <Field label="Carta">{ticket.cartaattivazione}</Field>
                <Field label="Tipo Titolo">{ticket.tipotitolo}</Field>
                <Field label="Causale">{ticket.causale}</Field>

                <Field label="Stato">{ticket.stato}</Field>
                <Field label="Ingresso">{checkDate}</Field>

                <Field label="Nome">{ticket.nome}</Field>
                <Field label="Cognome">{ticket.cognome}</Field>

                <Field label="Settore">{ticket.settore}</Field>
                <Field label="Settore Fisico">{ticket.settorefisico}</Field>
                <Field label="Fila">{ticket.fila}</Field>
                <Field label="Posto">{ticket.posto}</Field>


            </fieldset>
        </Fragment>
    );
}

const TicketDetails: IPage = {

    name: "ticket-details",
    title: "Dettagli",
    route: "/ticket/:eventId/:barcode",
    container: Home,
    content: <TicketDetailsContent />
}

registerPage(TicketDetails);

export default TicketDetails;